import submissionFailed from "../assets/submissionFailed.svg";
import submissionSuccessSatisfied from "../assets/submissionSuccessSatisfied.svg";
import submissionSuccessNotSatisfied from "../assets/submissionSuccessNotSatisfied.svg";

export const OUTCOME_TYPES = {
  SUCCESS_POSITIVE: "success_positive",
  SUCCESS_NEGATIVE: "success_negative",
  FAILURE: "failure",
};

export const submissionOutcomes = {
  [OUTCOME_TYPES.SUCCESS_POSITIVE]: {
    logo: submissionSuccessSatisfied,
    languageTitleKey: "survey_thankyou",
    languageDescriptionKey: "survey_submitted_description_success",
  },
  [OUTCOME_TYPES.SUCCESS_NEGATIVE]: {
    logo: submissionSuccessNotSatisfied,
    languageTitleKey: "survey_thankyou",
    languageDescriptionKey: "survey_submitted_description_success",
  },
  [OUTCOME_TYPES.FAILURE]: {
    logo: submissionFailed,
    languageTitleKey: "survey_submitted_title_failure",
    languageDescriptionKey: "survey_submitted_description_failure",
  },
};
